import { CreditCard, Truck } from "lucide-react";

const ITEMS = [
  { icon: CreditCard, text: "PAGA IN COMODE RATE CON KLARNA!", klarna: true },
  { icon: Truck, text: "SPEDIZIONE GRATUITA IN TUTTA ITALIA!" },
];

const Row = ({ hidden }) => (
  <div className="lt-marquee-track flex shrink-0 items-center gap-10 pr-10" aria-hidden={hidden || undefined}>
    {[0, 1, 2].flatMap((n) =>
      ITEMS.map(({ icon: Icon, text, klarna }) => (
        <span key={`${n}-${text}`} className="flex items-center gap-3 whitespace-nowrap">
          {klarna ? (
            <span className="rounded-md bg-[#FFB3C7] px-2 py-0.5 text-[11px] font-extrabold tracking-normal text-[#0A0B0E]">Klarna.</span>
          ) : (
            <Icon className="h-4 w-4 text-[#4D94FF]" />
          )}
          <span>{text}</span>
          <span className="h-1 w-1 rounded-full bg-white/40" />
        </span>
      ))
    )}
  </div>
);

export const PromoTicker = () => (
  <div className="lt-marquee relative overflow-hidden border-b border-white/10 bg-[#0A0B0E] py-2.5 text-[12px] font-semibold tracking-[0.14em] text-white" data-testid="promo-ticker" role="marquee" aria-label="Paga in comode rate con Klarna. Spedizione gratuita in tutta Italia.">
    <div className="flex w-max">
      <Row />
      <Row hidden />
    </div>
  </div>
);
